export default __webpack_public_path__ + "a74f47e13e569db1a434473add095428.svg";